import { render, staticRenderFns } from "./clientAttribute.vue?vue&type=template&id=28e01a58&scoped=true&"
import script from "./clientAttribute.vue?vue&type=script&lang=js&"
export * from "./clientAttribute.vue?vue&type=script&lang=js&"
import style0 from "./clientAttribute.vue?vue&type=style&index=0&id=28e01a58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e01a58",
  null
  
)

export default component.exports